import { Input } from './base/Input';
import { Label } from './base/Label';

export const Radio = {
  Input,
  Label,
};
